
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service-and-amc",
      function () {
        return require("private-next-pages/customer-service-and-amc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service-and-amc"])
      });
    }
  